import React from 'react';

import { EHashLinks } from '@enum';

import { SectionContainer, SectionContent } from './SectionWrapper.styled';

import { SectionWrapperProps } from './SectionWrapper.types';

export const SectionWrapper = ({
  sectionId = EHashLinks.home,
  background,
  children,
}: SectionWrapperProps) => (
  <SectionContainer id={sectionId}>
    {background}
    <SectionContent>{children}</SectionContent>
  </SectionContainer>
);
